import Vue from 'vue';
import AuthService from './auth-service';
import config from './api-config';
import qs from 'qs';
import TokenWebsite from './tokan-service';
import { EncryptionService } from './esencryption';
import { camelCase } from "lodash"; // Install lodash if not already: npm install lodash
import { DecryptionService } from './decrytion';
import { Traninglist } from '../models/training-types';
export class GeneralService {
    private auth = new AuthService();

    private stepWorkDayId = '4f7ca100-74db-4ac1-af1f-52fdbd62ebfa';
    private tokenService = new TokenWebsite();

    //"f71d4959-557c-45d9-abb6-52732085acfd" //Engineering workday id "8b2ce4bc-a712-4265-b5a2-e83439686fdf" //ics workday id "4f7ca100-74db-4ac1-af1f-52fdbd62ebfa" //Medical workday id
 toCamelCase(obj: any): any {
        if (Array.isArray(obj)) {
            return obj.map((item) => this.toCamelCase(item));
        } else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce((acc: any, key: string) => {
                acc[camelCase(key)] = this.toCamelCase(obj[key]);
                return acc;
            }, {});
        }
        return obj;
    }
    public async programs() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        if (!this.auth.isAuthenticated()) {
            this.auth.logout();
        }

        const response = await Vue.axios(
            {
                method: 'post',
                url: config.getUserProgram,
                withCredentials: true,
                data: {
                    val: this.auth.session.userId,
                },
                ...configCMS,
            },

        );

        const body = response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as UserProramsModel[];
    }




    public async classlevel(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserClass,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS,
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as UserClassModel[];
    }

    public async subjects(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserSubjects,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async getDayWorkEx(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getDayWorkEx,
            { WorkDayId: Id, UserId: this.auth.session.userId, Module: 2 }, configCMS);

        return await response.data;
    }

    public async getTestStep(Id, WorkDayId) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getTestStep,
            { TestId: Id, WorkDayId: WorkDayId }, configCMS);

        return await response.data;
    }

    public async gettokenwebsite(UserName: string, Password: string, UserEmail: string, DevieId: string, DeviceIP: string, LoginWith: string) {

        const configCMS = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },

        };
        var uname = EncryptionService.encrypt(UserName);
        var upass = EncryptionService.encrypt(Password);
        var ulogin = EncryptionService.encrypt(UserEmail);
        var devieId = EncryptionService.encrypt(DevieId);

        var deviceip = EncryptionService.encrypt(DeviceIP);
        var loginwith = EncryptionService.encrypt(LoginWith);




        try {
            const requestBody = {
                UserName: uname,
                Password: upass,
                UserEmail: ulogin,
                DeviceId: devieId,
                DeviceIP: deviceip,
                LoginWith: loginwith

            };

            const response = await Vue.axios.post('https://my.hadaf.edu.pk/auth/TokenWebSite',
                requestBody);
            if (response.status !== 200) {
                throw new Error(response.data?.message || "Login API error");
            }
            let decryptedData;
            if (response.data?.data) {
                const decryptedBody = EncryptionService.decrypt(response.data.data);
                decryptedData = JSON.parse(decryptedBody);
            } else {
                decryptedData = response.data;
            }

            console.log("? Decrypted response:", decryptedData);
            return decryptedData;

        } catch (error) {
            console.error("? Login API error:", error);
            throw error;
        }

    }

    public async getWorkDayId(ProgramId, Batch) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getWorkDayId,
            { ProgramId: ProgramId, Batch: Batch, Module: 2 }, configCMS);

        return await response.data;
    }

    public async getQuestionsExam(workdayid, title) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getQuestionsExam,
            { WorkDayId: workdayid, Title: title, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async updateAnswerExam(worksheetid, question, answer, isReview) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.updateAnswerExam,
            { examResultId: config.createGuid(), workSheetId: worksheetid, userId: this.auth.session.userId, question: question, answerValue: answer, isReview: isReview }, configCMS);

        return await response.data;
    }

    public async getResultExam(workdayid, title) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getResultExam,
            { WorkDayId: workdayid, Title: title, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async resetTest(workdayid, title) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.resetTest,
            { WorkDayId: workdayid, Title: title, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async getWorkSheet(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getWorkSheet,
            { TestId: Id }, configCMS);

        return await response.data;
    }


    public async smartSubjects(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserSmartSubjects,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async smartLearningTopics(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserSmartTopics,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async smartChapterTopics(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserSmartChapterTopics,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as TopicsModel[];
    }

    public async smartChapters(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserSmartChapterTopicsEx,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async mcqsubjects(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getMUserSubjects,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async testsubjects(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getCUserSubjects,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }
  public async getTrainingCourses(Id) {

        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };

        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        const requestBody = {
            organization: Id,
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            audienceCode: "STUDENT",
        };

        const response = await Vue.axios.post(config.getTrainingCourses,
            requestBody, configCMS)

        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }
           
        return body as Traninglist[];
    }
public async getcertificate(Id) {

        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
         let trainingId: any = '';
        let trainingName: any = '';
       let candidateName: any = '';

     if (typeof Id === 'string') {
         const parts = Id.split('?');
         trainingId = parts[0] || '';
         trainingName = parts[1] || '';
         candidateName = parts[2] || '';
     }
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
           trainingId:trainingId,
           trainingName:trainingName,
           candidateName:candidateName,
        };

        const response = await Vue.axios.post(config.getcertificate,
            requestBody, configCMS)

        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }
public async getprogressbar(Id) {

        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };

        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
           id:Id,
           audience:'STUDENT',
        };

        const response = await Vue.axios.post(config.getprogressbar,
            requestBody, configCMS)

        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }
    public async getTrainingVideosContent(Id) {

        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        let referenceValue: any = '';
        let contentTypeId: any = '';
        let contentType: any = '';
        let contentIds: any[] = [];

        if (typeof Id === 'string') {
            const parts = Id.split('?');
            contentTypeId = parts[0] || '';
            referenceValue = parts[1] || '';
            contentType = parts[2] || '';
            const idsPart = parts.slice(3).join('?');
            if (idsPart) {
                try {
                    const parsed = JSON.parse(idsPart);
                    contentIds = Array.isArray(parsed) ? parsed : [parsed];
                } catch (e) {
                    contentIds = idsPart.length > 0 ? idsPart.split(',') : [];
                }
            }
        }


        const requestBody: any = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            includeTags: false,
            referenceType: 'Traning',
            referenceValue: referenceValue,
            contentTypeId: contentTypeId,
            contentType: contentType,
            contentIds: contentIds,
            audienceCode: "STUDENT",
        };

        const response = await Vue.axios.post(config.getTrainingVideosContent,
            requestBody, configCMS)

        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }
    public async getTrainingModules(Id) {

        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };

        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            id: Id,
            audience: "STUDENT",
        };

        const response = await Vue.axios.post(config.getTrainingModules,
            requestBody, configCMS)

        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async getTrainingQuiz(Id) {
 
        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
            //  withCredentials: false,  // important!
 
        };
 
        let trainingModuleId: any = '';
        let quizId: any = '';
 
 
        if (typeof Id === 'string') {
            const parts = Id.split('?');
            trainingModuleId = parts[0] || '';
            quizId = parts[1] || '';
        }
 
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            trainingModuleId: trainingModuleId,
            quizId: quizId,
            audience: "STUDENT",
        };
        const response = await Vue.axios.post(config.getTrainingQuiz,
            requestBody, configCMS)
        var body = await response.data;
 
        const bodyDecrypt = DecryptionService.decrypt(body.data);
        body.data = this.toCamelCase(JSON.parse(bodyDecrypt));
        if (response.status !== 200) {
            throw Error(body.message);
        }
 
        return body;
    }
 
public async getGetActionLogs(Id) {
       
        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
 
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";  
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            referenceType: 'TRAINING',
            referenceValue: Id,
        };
 
        const response = await Vue.axios.post(config.getActionLogs,
            requestBody, configCMS)
 
        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }
 
        return body as GActivity[];
    }
    public async ppsubjects(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserPPSubjects,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }


     public async submitTrainingQuiz(payload: any) {
        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
       
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
         const requestBody = payload;
        const response = await Vue.axios.post(config.submitquiztraining, requestBody, configCMS);
        const body = await response.data;
 
        if (response.status !== 200) {
            throw Error(body.message);
        }
 
        return body;
    }
    public async chapters(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserChapters,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async videoTopics(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getVideoTopics,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as any[];
    }

    public async videoTopicsEnable(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.setVideoTopicEnable,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as any[];
    }

    public async topics(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getUserTopics,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async chapterTopics(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getChapterTopics,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as TopicsModel[];
    }




























    // insertMcq moved to ARVO section below

    // //*********************************************************

    public async mcq_subject(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getMcqSubject,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }




























    public async getSheetAnswersPast(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getSheetAnswersPast,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as any;
    }





























































    public async mcq_chapter(Id, type, number) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getMcqChapter,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id + ':' + type + ':' + number,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }

    public async mcq_topic(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getMcqTopics,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as GActivity[];
    }
 public async trainiguseractionlog(Id) {
       
        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
        let quizid: any = '';
        let traningmoduleid: any = '';
        let contenttype: any = '';
        let traningid: any = '';
 
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
 
        if (typeof Id === 'string') {
            const parts = Id.split('?');
            contenttype = parts[0] || '';
            quizid = parts[1] || '';
            traningid = parts[2] || '';
            traningmoduleid = parts[3] || '';
        }
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            entityType: contenttype,
            entityId: quizid,
            referenceType: 'TRAINING',
            referenceValue: traningid,
            isQuizRetake: true,
            parentEntityType: 'TRAINING_MODULE',
            parentEntityValue: traningmoduleid,
        };
 
        const response = await Vue.axios.post(config.trainiguseractionlog,
            requestBody, configCMS)
 
        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }
 
        return body as GActivity[];
    }
    // public async getsubjectlist(Id) {
    //     const responce = await this.http.fetch(config.getsubjectlist, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body;
    // }
public async getprofileactionlog(Id) {
       
        const jwtResponse = localStorage.getItem('jwtToken');
        if (!jwtResponse) {
            throw new Error('JWT token not found in localStorage');
        }
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtResponse}`,
            },
        };
        let entityid: any = '';
        let traningmoduleid: any = '';
        let contenttype: any = '';
        let traningid: any = '';
 
        let moduleName = JSON.parse(localStorage.getItem("isToggled")!) ? "El" : "Academic Calender";
 
        if (typeof Id === 'string') {
            const parts = Id.split('?');
            contenttype = parts[0] || '';
            entityid = parts[1] || '';
            traningid = parts[2] || '';
            traningmoduleid = parts[3] || '';
        }
        const requestBody = {
            organization: 'HADAF',
            module: moduleName,
            device: "Web",
            email: this.auth.session.userName,
            entityType: contenttype,
            entityId: entityid,
            referenceType: 'TRAINING',
            referenceValue: traningid,
            // isQuizRetake: true,
            parentEntityType: 'TRAINING_MODULE',
            parentEntityValue: traningmoduleid,
        };
 
        const response = await Vue.axios.post(config.getprofileactionlog,
            requestBody, configCMS)
 
        const body = await response.data.data;
        if (response.status !== 200) {
            throw Error(body.message);
        }
 
        return body as GActivity[];
    }
    public async getrating(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getrating,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async getratingSave(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getratingSave,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    // Alias methods for compatibility




    // GetNewRatingFeedback and ratingSaveList moved to ARVO section below

    // //*********************************************************

    // public async ass_subject(Id) {
    //     const responce = await this.http.fetch(config.assSubject, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // public async ass_chapter(Id) {
    //     const responce = await this.http.fetch(config.assChapter, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // public async ass_topic(Id) {
    //     const responce = await this.http.fetch(config.assTopcs, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // //*********************************************************

    // public async class_video(Id) {
    //     const responce = await this.http.fetch(config.classVideo, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // public async chaptersmaxwatchedavergae(Id) {
    //     const responce = await this.http.fetch(config.chaptersmaxwatchedavergae, { method: 'post', body: json(Id + ':' + this.auth.session.userId) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as VActive[];
    // }


    // public async chaptersmaxwatchedavergaesubjectwise(Id, subject) {
    //     const responce = await this.http.fetch(config.chaptersmaxwatchedavergaesubjectwise, { method: 'post', body: json(Id + ':' + this.auth.session.userId + ':' + subject) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as VActive[];
    // }

    // public async chaptersmaxattemptedavergae(Id) {
    //     const responce = await this.http.fetch(config.chaptersmaxattemptedavergae, { method: 'post', body: json(Id + ':' + this.auth.session.userId) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as VActive[];
    // }

    // public async chaptersmaxattemptedavergaebysubject(Id, subject) {
    //     const responce = await this.http.fetch(config.chaptersmaxattemptedavergaebysubject, { method: 'post', body: json(Id + ':' + this.auth.session.userId + ':' + subject) });
    //     const body = await responce.json();
    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as VActive[];
    // }

    // public async class_mcq(Id) {
    //     const responce = await this.http.fetch(config.classMcq, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // public async class_ass(Id) {
    //     const responce = await this.http.fetch(config.classAss, { method: 'post', body: json(this.auth.session.userId + ':' + Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as GActivity[];
    // }

    // //*********************************************************************

    // public async assCounted() {
    //     const responce = await this.http.fetch(config.assCount, { method: 'post', body: json(this.auth.session.userId) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as Summary[];
    // }

    public async questions(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getTopicQuestions,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as QuestionsModel[];
    }

    public async answers(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getQuestionAnswer,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as AnswersModel[];
    }

    public async getVocabExtended() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'get',
            url: config.getVocabExtended,
            withCredentials: true,
            ...configCMS
        });


        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as any;
    }

    // public async questionsAll(Id) {
    //     const responce = await this.http.fetch(config.allQuestions, { method: 'post', body: json(Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    // return body as Question[];
    // }

    public async chapterQuestions(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.GetChapterQuestions,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as QuestionE[];
    }

    public async sendData(data) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: 'https://analytics.pgc.edu/pgcdata/data/',
            data: data,
            ...configCMS
        });

        const body = await response.data;

        return body;
    }

    public async sendQuestion(data, type) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: type ? config.sendQuestion : config.sendQuestionEx,
            data: data,
            ...configCMS
        });

        const body = await response.data;

        return body;
    }

    public async getQuestionsWAnswers(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getQuestionsWAnswers,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async getVideoQuestions(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getVideoQuestions,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async updateTopicMarks(Id, Marks) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.updateTopicMarks,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id + ':' + Marks,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async getTopicMarks(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getTopicMarks,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }




























    public async getQuestionsWAnswersAlt(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getQuestionsWAnswersAlt,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }


    public async getIP() {

        await fetch('https://api.ipify.org?format=json')
            .then(x => x.json())
            .then(({ ip }) => {
                localStorage[config.currentIpAddress] = ip;
            });
    }

    public async boardsAll(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getAllBoards,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as Boards[];
    }

    // public async className(Id) {
    //     const responce = await this.http.fetch(config.className, { method: 'post', body: json(Id) });
    //     const body = await responce.json();

    //     if (responce.status !== 200)
    //         throw Error(body.message);

    //     return body as LevelName[];
    // }

    public async getPdf(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getpastpapers,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as getpastpapers[];
    }

    public async saveDailyQuestion(Id: string, dateattempted: Date, answerattempted: boolean) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.saveDailyQuestion,
            withCredentials: true,
            data: {
                val: this.auth.session.userId + ':' + Id,
                date: dateattempted,
                correct: answerattempted,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async setDailyQuestion(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.setDailyQuestion,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async getDailyQuestion(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getDailyQuestion,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body as QuestionE;
    }

    public async getGlobalStatistics(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.getGlobalStatistics,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async processFb(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios({
            method: 'post',
            url: config.processFb,
            withCredentials: true,
            data: {
                val: Id,
            },
            ...configCMS
        });

        const body = await response.data;

        if (response.status !== 200) {
            throw Error(body.message);
        }

        return body;
    }

    public async getInfo(Id: string, DId: string) {

        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id,
            Device_ID: DId,
        };

        const response = await Vue.axios.post('https://ems.edu.pk/api/Mobile/GetInfo',
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    // public async getInfoEMS(Id: string){
    //      const jwtToken = this.tokenService.getJwtToken();
    //  const configCMS = {
    //       headers: {
    //          'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${jwtToken}`,
    //       },
    //   };

    //     const requestBody = {
    //         Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
    //     };


    //     const response = await Vue.axios.post(config.getStudentInfoEMS,
    //     requestBody,configCMS);

    //     return await response.data;
    // }
    public async getInfoEMS(Id: string) {
        try {
            const response = await this.tokenService.getStudentInfoEMS_Encrypt(Id);
            return response; // or just `response` depending on your return type
        } catch (error) {
            console.error("Error fetching EMS info:", error);
            throw error;
        }
    }
    public async getTeacherSubject(Id: string, DId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            StudentID: Id,
            Device_ID: DId,
        };

        const response = await Vue.axios.post('https://ems.pgc.edu.pk/api/Mobile/get_teacher_list',
            requestBody, configCMS)

        return await response.data;
    }

    public async askQuestion(Id: string, TId: string, SId: string, Q: string, CSId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };


        const requestBody = {
            Student_ID: Id,
            Teacher_ID: TId,
            Subject_ID: SId,
            Question: Q,
            Section_ID: CSId,

        };

        const response = await Vue.axios.post('https://my.hadaf.edu.pk/api/Mobile/QuestionSend',
            requestBody, configCMS);

        return await response.data;
    }

    public async getAttendance(Id: string, DId: string, CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id,
            Device_ID: DId,
            Class_Level_ID: CLId,
        };

        const response = await Vue.axios.post('https://el.pgc.edu/api/middleware/GetAttendance',
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    public async getTimeTable(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
        };

        const response = await Vue.axios.post(config.getTimetableEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getStudentChat(id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        let Id = this.auth.session.userName;

        const requestBody = {
            Student_ID: id,
        };

        const response = await Vue.axios.post(config.getStudentChat,
            requestBody, configCMS);

        return await response.data;
    }

    public async getAttendanceEMS(Id: string, CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Class_Level_ID: CLId,
        };

        const response = await Vue.axios.post(config.getAttendanceEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getWorkStep(CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            workDayId: CLId,
        };

        const response = await Vue.axios.post(config.getWork,
            requestBody, configCMS);

        return await response.data;
    }

    public async getTest(Id, WorkDayId) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getTest,
            { TestId: Id, WorkDayId: WorkDayId }, configCMS);

        return await response.data;
    }

    public async getWorkStepX(CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            workDayId: CLId,
        };

        const response = await Vue.axios.post(config.getWorkX,
            requestBody, configCMS);

        return await response.data;
    }

    public async getAttendanceDetailEMS(Id: string, startDate: string, endDate: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Start_Date: startDate,
            End_Date: endDate,
        };

        const response = await Vue.axios.post(config.getDetailAttendanceEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getAttendanceMonth(Id: string, startDate: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Start_Date: startDate,
        };

        const response = await Vue.axios.post(config.getOneMonthAttendance,
            requestBody, configCMS);

        return await response.data;
    }

    public async getExamEMS(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
        };

        const response = await Vue.axios.post(config.getExamEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getExamEx(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
        };

        const response = await Vue.axios.post(config.getAllExamResult,
            requestBody, configCMS);

        return await response.data;
    }

    public async getExamDetailEMS(Id: string, exam_id: string, exam_title: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Class_Exam_ID: exam_id,
            Exm_Title: exam_title,
        };

        const response = await Vue.axios.post(config.getExamDetailEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getExamDetailEMSOld(Id: string, exam_id: string, exam_date: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Class_Exam_ID: exam_id,
            Exm_Dated: exam_date,
        };

        const response = await Vue.axios.post(config.getExamDetailEMSOld,
            requestBody, configCMS);

        return await response.data;
    }

    public async getFeesEMS(Id: string, CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id.indexOf('@') !== -1 ? Id.split('@')[0] : Id,
            Class_Level_ID: CLId,
        };

        const response = await Vue.axios.post(config.getFeesEMS,
            requestBody, configCMS);

        return await response.data;
    }

    public async getFeeChallan(Id: string, DId: string, CLId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id,
            Device_ID: DId,
            Class_Level_ID: CLId,
        };

        const response = await Vue.axios.post('https://el.pgc.edu/api/middleware/GetFeeChallan',
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    public async getExams(Id: string, DId: string, CLId: string, CaId: string, EnId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id,
            Device_ID: DId,
            Class_Level_ID: CLId,
            Enrollment_ID: EnId,
            Campus_ID: CaId,
        };

        const response = await Vue.axios.post('https://el.pgc.edu/api/middleware/GetExamInfo',
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    public async getVideoToken(videoURL: string, encryption: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            videoURL: videoURL,
            encryption: encryption,
        };

        const response = await Vue.axios.post(config.getVideoToekn,
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    public async getQuestionsWA(workdayid, title) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getQuestionWA,
            { WorkDayId: workdayid, Title: title, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async getExamDetail(Id: string, DId: string, CId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };

        const requestBody = {
            Student_ID: Id,
            Device_ID: DId,
            Class_Exam_ID: CId,
        };

        const response = await Vue.axios.post('https://el.pgc.edu/api/middleware/GetExamDetail',
            qs.stringify(requestBody), configCMS);

        return await response.data;
    }

    public async subjectTestfind(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.subjectTestfind,
            { id: Id }, configCMS);

        return await response.data;
    }

    public async subjectSetsAll() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.get(config.subjectSetsAll, configCMS);

        return await response.data;
    }

    public async getAllBoards() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.get(config.getBoards, configCMS);

        return await response.data;
    }

    public async resetPassword(Id, cnic) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post('https://my.hadaf.edu.pk/api/OnlineAdmission/GetPassword',
            { RollNo: Id, Cnic: cnic }, configCMS);

        return await response.data;
    }

    public async getWork(ProgramId, Batch) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getAllWork,
            { ProgramId: ProgramId, Batch: Batch }, configCMS);

        return await response.data;
    }

    public async getBoardPrograms(id) {

        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getBoardPrograms,
            { val: id }, configCMS);

        return await response.data;
    }

    public async getBoardProgramsEx(binded) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getBoardProgramsEx,
            { val: binded }, configCMS);

        return await response.data;
    }

    public async getVideos(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getAllWork,
            { WorkDayId: Id, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async getAcademicCalendar(id, clid) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getAcademicCalendar,
            { Student_ID: id, Class_ID: clid }, configCMS);

        return await response.data;
    }

    public async getNotes(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getNotes,
            { WorkDayId: Id, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async getMCQs(Id) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getMCQs,
            { WorkDayId: Id, UserId: this.auth.session.userId }, configCMS);

        return await response.data;
    }

    public async userLog() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.logUser,
            { val: this.auth.session.userName }, configCMS);

        return await response.data;
    }

    public async getNotifications(Id: string, Limit: number) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getNotifications, { Student_ID: Id, limits: Limit }, configCMS);
        return await response.data;
    }

    public async pushSurvey(Id: string, Remarks: string, Data: any) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.pushSurvey, { RollNo: Id, Operation: JSON.stringify(Data), Remarks: Remarks }, configCMS);

        return await response.data;
    }

    public async getMandatorySurvey(AdmissionID: string, CLId: string, NotificationId: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.getMandatorySurvey, { ProvidedString: NotificationId + '?' + AdmissionID + '?' + CLId }, configCMS);

        return await response.data;
    }

    public async insertMandatorySurvey(AdmissionID: string, NotificationId: string, List: object) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwtToken}`,
            },
        };
        const response = await Vue.axios.post(config.insertMandatorySurvey, { admissionFormId: AdmissionID, surveyMasterId: NotificationId, list: JSON.stringify(List) }, configCMS);
        return await response.data;
    }






    // ── ARVO / EL methods ──

    public async mcqArvoChapters(Id: string, programname: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web?' + programname;
        const response = await Vue.axios.post(config.getmcqArvoChapters, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data as GActivity[];
    }

    public async mcqOldChapters(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getmcqOldChapters, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data as GActivity[];
    }

    public async getQuestionsWAnswersArvo(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + this.auth.session.userName + '?' + moduleName + '?Web';
        const response = await Vue.axios.post(config.getQuestionsWAnswersArvo, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data;
    }

    public async getQuestionsWAnswersPGC(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getQuestionsWAnswersPGC, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data;
    }

    public async getarvosmartChapters(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getarvosmartChapters, { Val: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data as GActivity[];
    }

    public async getarvosmartVideoContent2(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getarvosmartVideoContent, { Val: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data as GActivity[];
    }

    public async getarvosmartELVideoContent(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getarvosmartVideoContent, { Val: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data;
    }

    public async getARVOSetupTags(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        const requestBody = { organization: Id, userEmail: this.auth.session.userName, module: moduleName, organizationCode: Id, device: 'Web' };
        const response = await Vue.axios.post(config.getARVOSetupTags, requestBody, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data;
    }

    public async getQuestionsWAnswersB(limit: number, chapters: any[]) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        const requestBody = { qCount: limit, year: null, data: chapters, Module: moduleName, UserEmail: this.auth.session.userName, Device: 'Web',organization: 'HADAF' };
        const response = await Vue.axios.post(config.getQuestionsWAnswersB, requestBody, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data.data;
    }

    public async insertSheetAnswers(Id: string, topicId: string, data: any) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const requestBody = { UserMcqResponseId: Id, UserId: this.auth.session.userId, TopicId: topicId, Operations: JSON.stringify(data), StatusId: 1 };
        const response = await Vue.axios.post(config.insertSheetAnswers, requestBody, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data as any;
    }

    public async updateSheetAnswers(Id: string, topicId: string, data: any) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const requestBody = { UserMcqResponseId: Id, UserId: this.auth.session.userId, TopicId: topicId, Operations: JSON.stringify(data), StatusId: 1 };
        const response = await Vue.axios.post(config.updateSheetAnswers, requestBody, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data as any;
    }

    public async getSheetAnswers(val: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.getSheetAnswers, { providedString: val }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data as any;
    }

    public async insertMcq(tw: McqAttempted) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.insertMcq, tw, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data as any;
    }

    public async insertTopicWached(requestBody: TopicsWatched) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.insertTW, requestBody, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return true;
    }

    public async ratingSave(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.ratingSave, { providedString: this.auth.session.userId + '?' + Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async ratingSaveList(Id: string, remarks: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.ratingSaveList, { providedString: this.auth.session.userId + '?' + Id + '?' + remarks }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async GetNewRatingFeedback() {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.get(config.NegativeVideoRatting, configCMS);
        return response.data;
    }

    public async getPGCtrating(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.GetPgcVideoRating, { providedString: this.auth.session.userId + '?' + Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async getVideoQuestionsArvo(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getVideoQuestionsArvo, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async getArvoTopicVideos(Id: string, isArvo?: any) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web?' + isArvo;
        const response = await Vue.axios.post(config.getArvoTopicVideos, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async getShortQuestionsArvo(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web';
        const response = await Vue.axios.post(config.getShortQuestionsArvo, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async expandTopicView(Id: string, isArvo?: any) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        let moduleName = JSON.parse(localStorage.getItem('isToggled')!) ? 'el' : 'Academic Calender';
        Id = Id + '?' + moduleName + '?' + this.auth.session.userName + '?Web?' + isArvo;
        const response = await Vue.axios.post(config.expandTopicView, { providedString: Id }, configCMS);
        if (response.status !== 200) throw Error(response.data.message);
        return response.data;
    }

    public async PGCQuizStatus(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.pGCQuizStatus, { ProvidedString: Id }, configCMS);
        return response.data;
    }

    public async getStudentBoardInfo(rollNo: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.getStudentBoardInfo, { Student_ID: rollNo }, configCMS);
        return response.data;
    }

    public async getStaffCheck(Id: string) {
        const jwtToken = this.tokenService.getJwtToken();
        const configCMS = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwtToken}` } };
        const response = await Vue.axios.post(config.getStaffCheck, { ProvidedString: Id }, configCMS);
        return response.data;
    }
}
